import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingCart, X } from 'lucide-react';
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(0);
  const notifications = [{
    name: 'Martín L.',
    city: 'Buenos Aires'
  }, {
    name: 'Santiago R.',
    city: 'Córdoba'
  }, {
    name: 'Facundo M.',
    city: 'Rosario'
  }, {
    name: 'Agustín P.',
    city: 'Mendoza'
  }, {
    name: 'Tomás G.',
    city: 'La Plata'
  }, {
    name: 'Joaquín F.',
    city: 'Mar del Plata'
  }, {
    name: 'Gonzalo S.',
    city: 'Tucumán'
  }, {
    name: 'Maximiliano D.',
    city: 'Salta'
  }, {
    name: 'Rodrigo V.',
    city: 'Santa Fe'
  }, {
    name: 'Ignacio B.',
    city: 'Neuquén'
  }];
  useEffect(() => {
    const showNotification = () => {
      setIsVisible(true);
      setCurrentNotification(Math.floor(Math.random() * notifications.length));
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    const initialDelay = setTimeout(showNotification, 3000);
    const interval = setInterval(showNotification, 15000);
    return () => {
      clearTimeout(initialDelay);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-353">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 max-w-[200px]" data-id="element-354">
          <div className="bg-[#1a1a1a] border border-green-500/50 rounded-xl p-2 shadow-lg shadow-green-500/20 relative" data-id="element-355">
            <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-500 hover:text-white transition-colors" data-id="element-356">
              <X className="w-3 h-3" data-id="element-357" />
            </button>

            <div className="flex items-start gap-2" data-id="element-358">
              <div className="w-6 h-6 rounded-full bg-gradient-to-br from-green-500 to-green-600 flex items-center justify-center flex-shrink-0" data-id="element-359">
                <ShoppingCart className="w-3 h-3 text-white" data-id="element-360" />
              </div>

              <div className="flex-1" data-id="element-361">
                <p className="text-[10px] font-bold text-green-500 mb-0.5" data-id="element-362">
                  ¡Compra Reciente!
                </p>
                <p className="text-white font-bold text-xs mb-0" data-id="element-363">
                  {notifications[currentNotification].name}
                </p>
                <p className="text-gray-400 text-[10px]" data-id="element-364">
                  {notifications[currentNotification].city} • Hace{' '}
                  {Math.floor(Math.random() * 15) + 1} min
                </p>
                <p className="text-[9px] text-gray-500 mt-1" data-id="element-365">
                  Compró: Formación en Detallado
                </p>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}